import { useEffect, useRef, useMemo } from "react";
import style from "./style.module.scss";

export default function MapPart() {
    const mapRef = useRef();
    const mapId = useMemo(() => Math.round(Math.random() * 1000000), []);

    useEffect(() => {
        const loader = () => {
            const pos = { lat: 36.4985692, lng: -4.9975664 };
            const map = new window.google.maps.Map(document.getElementById("mapComponent" + mapId), {
                center: pos,
                zoom: 18,
            });

            const vhengaMarker = new window.google.maps.Marker({
                position: pos,
                map: map,
                title: "Vhenga",
                icon: {
                    url: "/Images/map/vhenga.png",
                    scaledSize: new window.google.maps.Size(150, 150)
                }
            })

        }

        if (!document.getElementById("googleMapsScript")) {
            const script = document.createElement("script");
            script.id = "googleMapsScript";
            script.src = "https://maps.googleapis.com/maps/api/js?key=AIzaSyDnCWRk8fQghOanT5JUeLPG3JMWAmIe9Vo";
            script.async = true;

            script.onload = loader;

            document.body.appendChild(script);
        } else {
            loader();
        }

    }, []);


    return <div className={style.mapPart + " row"}>
        <div className={style.map} ref={mapRef} id={"mapComponent" + mapId} />
        <div style={{ backgroundImage: `url("/Images/map/image.jpg")` }} className={style.image} alt="map" />
    </div>
}